// Google Business profili — xizmat sahifasi kontenti (Innobek)

const uz = {
    meta: {
        title: "Google Business profili — xaritada ko'rinish va mahalliy SEO",
        description:
            "Google Business profilini sozlash va yuritish: xarita paketiga chiqish, sharhlar bilan ish, NAP birxilligi, foto va postlar. Yuritish oyiga 2 500 000 so'mdan.",
        keywords: [
            "Google Business profili",
            "Google Biznes profili",
            "Google xaritada biznes",
            "mahalliy SEO",
            "xarita paketi",
            "map pack",
            "Google sharhlar",
            "NAP birxilligi",
            "yaqin atrofda qidiruv",
        ],
    },
    hero: {
        eyebrow: "Google Business / Mahalliy SEO",
        h1: "Google Business profili — xaritada birinchi uchlikda bo'ling",
        lead:
            "Odam «yaqin atrofda stomatologiya» deb qidirsa, Google unga avval xarita va uchta biznes ko'rsatadi. Aynan shu uchtaga kim tushsa, qo'ng'iroqni o'sha oladi. Biz profilingizni shu uchlikka olib chiqish uchun ishlaymiz.",
        ctaPrimary: "Profilni bepul tekshirish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Xaritadagi joylashuv va marshrut so'rovlari",
            "Sharhlarga javob — o'zbek va rus tilida",
            "NAP ma'lumotlari barcha manbalarda bir xil",
            "Oylik hisobot: qo'ng'iroq, marshrut, klik",
        ],
    },
    intro: {
        h: "Google Business profili nima va u nima uchun kerak",
        p: [
            "Google Business profili — kompaniyangizning Google qidiruvi va Google Maps'dagi bepul kartochkasi. Unda manzil, ish vaqti, telefon, foto, xizmatlar ro'yxati va mijoz sharhlari bo'ladi. Odam sizni nomingiz bilan qidirsa yoki «yaqin atrofda» tipidagi so'rov yozsa, aynan shu kartochka ko'rinadi.",
            "Mahalliy so'rovlarda Google odatiy natijalardan oldin xarita bloki — «map pack» deb ataladigan uchlikni ko'rsatadi. Statistikaga ko'ra mahalliy qidiruvdagi bosishlarning katta qismi aynan shu uch joyga tushadi. To'rtinchi bo'lish deyarli beshinchi bo'lish bilan bir xil natija beradi, chunki qolganini ko'rish uchun foydalanuvchi qo'shimcha tugmani bosishi kerak.",
            "Google bu uchlikni uchta omilga qarab tanlaydi. Birinchisi — moslik: profil ma'lumotlari so'rovga qanchalik mos. Ikkinchisi — masofa: qidirayotgan odamga qanchalik yaqinsiz. Uchinchisi — nufuz: sharhlar soni va bahosi, saytdagi eslatmalar, kataloglardagi yozuvlar. Masofani o'zgartira olmaysiz, qolgan ikkitasi esa to'liq sizning ishingiz.",
            "O'zbekistonda bu yo'nalish hali to'liq ishlatilmayapti. Ko'p biznesning profili yo umuman yo'q, yo tasdiqlanmagan, yoki ma'lumotlari besh yil oldingi. Ba'zi kompaniyalarda ikki-uchta dublikat kartochka turadi va ular bir-birining pozitsiyasini yeydi. Bu — raqobatchilaringiz e'tiborsiz qoldirgan va sizga arzonga tushadigan kanal.",
            "Yana bir tez-tez uchraydigan xato — manzil va nom har joyda har xil yozilgani. Saytda «Chilonzor tumani, 12-kvartal», profilda «Chilanzarskiy rayon, kvartal 12», katalogda yana boshqacha. Google bu yozuvlarni bitta biznesga bog'lay olmaydi va profilning nufuzi bo'linib ketadi. Buni tuzatish NAP birxilligi deb ataladi va biz ishni odatda shundan boshlaymiz.",
        ],
    },
    definition: {
        term: "Google Business profili nima?",
        text:
            "Google Business profili — kompaniyaning Google qidiruvi va Google Maps'dagi bepul kartochkasi: manzil, ish vaqti, telefon, foto, xizmatlar va mijoz sharhlari. U mahalliy so'rovlarda xarita paketiga chiqish uchun asosiy vosita hisoblanadi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Xizmatga nimalar kiradi",
        sub: "Profil holatiga qarab kerakli ishlar tanlanadi — tekshiruvdan keyin aniq ro'yxat beriladi.",
        items: [
            "Profilni yaratish yoki egalik huquqini qaytarib olish",
            "Tasdiqlash (verifikatsiya) jarayonini oxirigacha olib borish",
            "Dublikat kartochkalarni topish va birlashtirish yoki o'chirish",
            "NAP birxilligi: nom, manzil va telefon barcha manbalarda bir xil",
            "To'g'ri asosiy va qo'shimcha kategoriyalarni tanlash",
            "Xizmatlar va mahsulotlar ro'yxatini to'ldirish, narx oraliqlari bilan",
            "Tavsif matni o'zbek va rus tilida, kalit so'zlar bilan",
            "Ish vaqti, bayram jadvali va xizmat ko'rsatish hududini sozlash",
            "Sifatli foto va videolar: tashqi ko'rinish, ichki, jamoa, ish jarayoni",
            "Xaritadagi nuqta va kirish joyini aniq belgilash",
            "Sharh yig'ish tizimi: QR kod, SMS shablon, xodimlar uchun ko'rsatma",
            "Barcha sharhlarga javob yozish, jumladan salbiylariga",
            "Savol-javob bo'limini to'ldirish va kuzatish",
            "Haftalik postlar: aksiya, yangilik, xizmat e'loni",
            "Buyurtma va bron tugmalarini ulash",
            "Mahalliy kataloglarda yozuvlar va Yandex Biznes profili",
            "Oylik hisobot: ko'rinish, qo'ng'iroq, marshrut so'rovlari, saytga o'tish",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Profil biznesga nima beradi",
        sub: "Bu — mahalliy biznes uchun eng arzon mijoz kanali.",
        items: [
            {
                t: "Xarita paketiga chiqish",
                d: "Mahalliy so'rovlarda Google avval uchta biznesni ko'rsatadi. Shu uchlikda bo'lish oddiy natijalardagi birinchi o'rindan ham qimmatliroq.",
            },
            {
                t: "To'g'ridan-to'g'ri qo'ng'iroq",
                d: "Foydalanuvchi saytga kirmasdan, kartochkadagi tugma orqali qo'ng'iroq qiladi yoki marshrut oladi. Yo'l qanchalik qisqa bo'lsa, ariza shuncha ko'p.",
            },
            {
                t: "Sharhlar ishonch beradi",
                d: "Ko'pchilik tanlovni sharhlar bahosidan boshlaydi. 4,7 ballik profil 3,9 ballikdan bir necha barobar ko'proq qo'ng'iroq oladi.",
            },
            {
                t: "Xarajat deyarli nol",
                d: "Profilning o'zi bepul. Reklamadan farqli o'laroq, bu yerda har bir ko'rinish uchun to'lov yo'q — faqat yuritish mehnati kerak.",
            },
            {
                t: "Natija tez ko'rinadi",
                d: "SEO oylab kutishni talab qiladi. To'ldirilgan profil esa odatda 3–6 hafta ichida ko'rinish va qo'ng'iroq raqamlarini sezilarli oshiradi.",
            },
            {
                t: "Sayt SEO'siga yordam beradi",
                d: "Profil, sayt va kataloglardagi bir xil ma'lumot Google uchun kuchli signal. Bu saytning mahalliy so'rovlardagi pozitsiyasini ham ko'taradi.",
            },
            {
                t: "Raqobatchilar buni qilmaydi",
                d: "O'zbekistonda ko'p biznesning profili tashlandiq holatda. Tartibli yuritilgan profil bilan siz ularni nisbatan oson ortda qoldirasiz.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlarga mos",
        h: "Kimlarga Google Business profili kerak",
        sub: "Mijoz sizga keladigan yoki siz mijozga boradigan har qanday biznesga.",
        items: [
            {
                t: "Jismoniy manzilli bizneslar",
                d: "Klinika, restoran, salon, do'kon, sport zali. Mijoz sizni xaritadan topadi va marshrut oladi.",
            },
            {
                t: "Xizmatni joyida ko'rsatuvchilar",
                d: "Klining, ko'chirish, ta'mirlash, evakuator. Manzilni yashirib, faqat xizmat hududini ko'rsatish mumkin.",
            },
            {
                t: "Ko'p filialli tarmoqlar",
                d: "Har bir filial uchun alohida profil kerak. Ular markazlashgan boshqarilsa, har biri o'z hududida chiqadi.",
            },
            {
                t: "Tibbiyot va ta'lim",
                d: "Bu sohalarda tanlov deyarli har doim sharhlarni o'qishdan boshlanadi. Profil bu yerda ishonch qurilmasi.",
            },
            {
                t: "Yangi ochilgan joylar",
                d: "Sayt hali yo'q bo'lsa ham, profil birinchi mijozlarni keltira boshlaydi. Eng tez ishga tushadigan kanal.",
            },
            {
                t: "Salbiy sharh olganlar",
                d: "Bir nechta yomon sharh bahoni tushirib yuborgan bo'lsa, tizimli ish bilan reyting bir necha oyda tiklanadi.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Google Business profili narxlari",
        sub: "Sozlash — bir martalik. Yuritish — oylik abonent to'lov.",
        note:
            "Profilning o'zi Google'da bepul: siz faqat uni to'g'ri qurish va muntazam yuritish ishiga to'laysiz. Ko'p filialli tarmoqlar uchun narx filiallar soniga qarab hisoblanadi. Tasdiqlash jarayonida Google ba'zan pochta orqali kod yuboradi yoki video tekshiruv so'raydi — bu 1–3 hafta qo'shimcha vaqt olishi mumkin va bizga bog'liq emas. Savollar: +998 90 954 12 62.",
        tiers: [
            {
                name: "Sozlash",
                tagline: "Bir martalik to'liq qurish",
                price: "2 500 000 so'm",
                priceNote: "bir martalik",
                term: "5–10 ish kuni (tasdiqlashdan tashqari)",
                best: "Profili yo'q yoki tashlandiq holatda bo'lgan bizneslar uchun",
                features: [
                    "Profilni yaratish yoki egalikni qaytarib olish",
                    "Tasdiqlash jarayonini oxirigacha olib borish",
                    "Dublikat kartochkalarni topish va birlashtirish",
                    "Kategoriyalar, xizmatlar va tavsif matnini to'ldirish",
                    "NAP ma'lumotlarini sayt bilan moslashtirish",
                    "10–15 ta foto joylash va xaritadagi nuqtani aniqlash",
                    "Sharh yig'ish uchun QR kod va SMS shablon",
                    "Profilni boshqarish bo'yicha qisqa o'qitish",
                ],
            },
            {
                name: "Yuritish",
                tagline: "Oylik ish va reyting o'sishi",
                price: "2 500 000 so'm",
                priceNote: "oyiga, bitta filial",
                term: "Oylik abonent to'lov",
                best: "Xarita paketiga chiqish va sharhlar reytingini ko'tarishni xohlaydiganlar uchun",
                featured: true,
                features: [
                    "Sozlash paketidagi barcha ishlar birinchi oyda",
                    "Haftada 1–2 ta post: aksiya, yangilik, xizmat",
                    "Barcha sharhlarga 24 soat ichida javob",
                    "Salbiy sharhlar bilan ishlash va o'chirishga ariza",
                    "Oyiga 5–10 ta yangi foto",
                    "Savol-javob bo'limini to'ldirish va kuzatish",
                    "Mahalliy kataloglarda yozuvlar va Yandex Biznes",
                    "Raqobatchilarning xaritadagi pozitsiyasini kuzatish",
                    "Oylik hisobot: ko'rinish, qo'ng'iroq, marshrut, klik",
                ],
            },
            {
                name: "Tarmoq",
                tagline: "Ko'p filialli boshqaruv",
                price: "6 000 000 so'm",
                priceNote: "oyiga, 3 tagacha filial",
                term: "Oylik abonent to'lov",
                best: "Filiallari bir nechta shahar yoki tumanda joylashgan tarmoqlar uchun",
                features: [
                    "Yuritish paketidagi barcha ishlar har bir filial uchun",
                    "Qo'shimcha har bir filial — oyiga 1 500 000 so'm",
                    "Markazlashgan boshqaruv va yagona kontent rejasi",
                    "Filiallar o'rtasida kannibalizatsiyani oldini olish",
                    "Har bir filial uchun alohida qo'nish sahifasi tavsiyasi",
                    "Filiallar kesimida taqqoslama hisobot",
                    "Xodimlar uchun sharh yig'ish bo'yicha ko'rsatma va treyning",
                    "Shaxsiy menejer",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Ish qanday olib boriladi",
        sub: "Birinchi natijalar odatda 3–6 hafta ichida ko'rinadi — bu SEO'dan ancha tezroq.",
        steps: [
            {
                t: "Profil auditi",
                time: "2–3 kun",
                d: "Mavjud profil, dublikatlar, NAP xatolari, sharhlar holati va raqobatchilarning xaritadagi pozitsiyasi tekshiriladi. Natija — muammolar ro'yxati.",
            },
            {
                t: "Egalik va tasdiqlash",
                time: "1–3 hafta",
                d: "Profil sizning nomingizga o'tkaziladi va tasdiqlanadi. Muddat Google'ning tekshiruv usuliga bog'liq — pochta kodi yoki video tekshiruv.",
            },
            {
                t: "NAP tozalash",
                time: "1–2 hafta",
                d: "Nom, manzil va telefon sayt, profil, ijtimoiy tarmoq va kataloglarda bir xil yozuvga keltiriladi. Dublikatlar birlashtiriladi.",
            },
            {
                t: "Profilni to'ldirish",
                time: "3–5 kun",
                d: "Kategoriyalar, xizmatlar, tavsif, ish vaqti, foto va xaritadagi nuqta. Bo'sh qolgan har bir maydon — yo'qotilgan ko'rinish.",
            },
            {
                t: "Sharh tizimini yo'lga qo'yish",
                time: "1 hafta",
                d: "QR kod, SMS shablon va xodimlar uchun ko'rsatma tayyorlanadi. Maqsad — sharhlar tasodifiy emas, muntazam kelishi.",
            },
            {
                t: "Doimiy yuritish",
                time: "har hafta",
                d: "Postlar chiqadi, yangi foto qo'shiladi, sharhlarga javob yoziladi, savollar yopiladi. Profil tirik ekani Google uchun ham signal.",
            },
            {
                t: "O'lchash va tuzatish",
                time: "har oy",
                d: "Ko'rinish, qo'ng'iroq va marshrut so'rovlari solishtiriladi. Qaysi post yoki foto ko'proq harakat keltirgani ko'riladi va reja shunga moslanadi.",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Mahalliy qidiruv uchun tayyorlangan loyihalar",
        sub: "Bu saytlar profil va xarita natijalari bilan birga ishlaydigan qilib qurilgan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["cleanza", "ipsum-pathology", "mountain-and-sea", "global-building-group"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Google Business bo'yicha ko'p beriladigan savollar",
        sub: "Xarita, sharhlar va NAP haqida aniq javoblar.",
        items: [
            {
                q: "Google Business profili xizmati qancha turadi?",
                a: "Innobek'da bir martalik sozlash 2 500 000 so'm, oylik yuritish 2 500 000 so'mdan boshlanadi. Ko'p filialli tarmoqlar uchun 6 000 000 so'mdan, uchtagacha filial kiradi, keyingi har bir filial oyiga 1 500 000 so'm. Profilning o'zi Google'da bepul — siz faqat ish uchun to'laysiz.",
            },
            {
                q: "Xarita paketiga (map pack) qanday chiqiladi?",
                a: "Google uchta omilga qaraydi: profilning so'rovga mosligi, qidirayotgan odamga masofa va biznesning nufuzi. Masofani o'zgartirib bo'lmaydi. Qolgan ikkitasi ustida ishlanadi: to'g'ri asosiy kategoriya, to'liq to'ldirilgan xizmatlar ro'yxati, muntazam kelib turadigan sharhlar, yangi fotolar, haftalik postlar va saytdagi mahalliy signallar. Bu ishlarning barchasi bir vaqtda olib borilganda uchlikka chiqish ehtimoli sezilarli oshadi.",
            },
            {
                q: "Natija qancha vaqtda ko'rinadi?",
                a: "Profil to'ldirilgandan keyin dastlabki o'zgarishlar odatda 3–6 hafta ichida ko'rinadi: ko'rinishlar soni, qo'ng'iroqlar va marshrut so'rovlari ortadi. Xarita paketidagi barqaror pozitsiya esa 2–4 oylik muntazam ishni talab qiladi, chunki sharhlar to'planishi va Google profilga ishonishi vaqt oladi. Bu SEO'dan ancha tezroq, lekin baribir bir kunlik ish emas.",
            },
            {
                q: "NAP birxilligi nima va u nega muhim?",
                a: "NAP — Name, Address, Phone, ya'ni nom, manzil va telefon. Bu uch ma'lumot sayt, profil, ijtimoiy tarmoq va barcha kataloglarda bir xil yozilishi kerak. Agar manzil bir joyda o'zbekcha, boshqasida ruscha va uchinchisida qisqartma bilan yozilsa, Google yozuvlarni bog'lay olmaydi va nufuz bo'linadi.",
            },
            {
                q: "Salbiy sharhni o'chirish mumkinmi?",
                a: "Faqat Google qoidalarini buzgan bo'lsa: haqorat, reklama, mavzuga aloqasiz matn yoki aniq soxta sharh. Bunda shikoyat yuboriladi, lekin qaror Google'niki va kafolat yo'q. Haqiqiy shikoyatni o'chirib bo'lmaydi — eng to'g'ri yo'l unga xotirjam, konkret javob yozish va muammoni hal qilish.",
            },
            {
                q: "Sharhlarni sotib olsa bo'ladimi?",
                a: "Yo'q, va biz buni qilmaymiz. Google soxta sharhlarni aniqlaydi: ular o'chiriladi, profil esa filtrga tushishi yoki butunlay o'chib ketishi mumkin. Xavf foydadan katta. Biz o'rniga haqiqiy mijozlardan sharh yig'ish tizimini quramiz — QR kod, SMS shablon va xodimlar uchun oddiy ko'rsatma bilan.",
            },
            {
                q: "Bir oyda nechta sharh yig'ish normal?",
                a: "Biznes hajmiga bog'liq, lekin asosiy qoida — tekis va tabiiy sur'at. Kichik biznes uchun oyiga 5–15 ta sharh yaxshi ko'rsatkich. Bir kunda yigirmata sharh kelishi esa shubha uyg'otadi va filtrga sabab bo'ladi. Muhimi — sharhlar to'xtamasligi, chunki eski sharhlar vaznini yo'qotadi.",
            },
            {
                q: "Manzilim yo'q, mijozga o'zim boraman — profil ochsa bo'ladimi?",
                a: "Ha, bo'ladi. Bunday bizneslar uchun xizmat hududi rejimi mavjud: manzil yashiriladi, o'rniga siz ishlaydigan tumanlar yoki shaharlar ro'yxati ko'rsatiladi. Klining, ko'chirish, ta'mirlash va evakuator xizmatlari aynan shu rejimda ishlaydi. Tasdiqlash uchun haqiqiy manzil baribir kerak bo'ladi, lekin u profilda ommaga ko'rinmaydi va mijozlar faqat hududni ko'radi.",
            },
            {
                q: "Bir nechta filial bo'lsa nima qilinadi?",
                a: "Har bir filial uchun alohida profil ochiladi va ularning barchasi bitta hisobdan markazlashgan holda boshqariladi. Muhim nuqta: filiallar bir-biriga juda yaqin joylashgan bo'lsa, ular o'zaro raqobatlasha boshlaydi va ikkalasining ham pozitsiyasi pasayadi. Shuning uchun kategoriyalar, xizmatlar ro'yxati va tavsif matnlari har bir filial uchun farqlantiriladi.",
            },
            {
                q: "Profilim boshqa odam nomida ochilgan — nima qilaman?",
                a: "Bu juda tez-tez uchraydigan holat: profilni avvalgi marketolog, dizayner yoki shunchaki tanish ochib qo'ygan bo'ladi. Google'da egalik huquqini so'rash uchun rasmiy tartib mavjud. Joriy egaga so'rov yuboriladi va u 3–7 kun ichida javob bermasa, boshqaruv huquqi sizga o'tadi. Biz bu jarayonni boshidan oxirigacha o'zimiz olib boramiz.",
            },
            {
                q: "Profil SEO o'rnini bosadimi?",
                a: "Yo'q, ular butunlay boshqa vazifani bajaradi. Profil mahalliy so'rovlarda va xaritada ishlaydi, sayt SEO'si esa ancha kengroq so'rovlar qamrovini beradi va ma'lumot izlayotgan mijozni ham tutadi. Lekin ular bir-birini kuchaytiradi: profildagi to'g'ri ma'lumot saytning mahalliy pozitsiyasini ko'taradi, sayt va undagi eslatmalar esa profilga nufuz qo'shadi.",
            },
        ],
    },
    cta: {
        h: "Profilingiz xaritada qanday ko'rinayotganini bilmoqchimisiz?",
        p: "Bepul tekshiruvda profilni raqobatchilar bilan solishtiramiz, dublikat va NAP xatolarini topamiz va nima qilish kerakligini ro'yxat bilan beramiz.",
        button: "Profilni bepul tekshirish",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/services/gbp-map-pack.webp",
            alt: "Google xarita paketi: mahalliy so'rov bo'yicha uchta biznes kartochkasi",
            caption: "Mahalliy so'rovlarda Google avval xaritani va uchta biznesni ko'rsatadi.",
            prompt:
                "Mockup of Google local map pack in search results: map on top with three pins, below three business listing cards with star ratings, review counts, addresses and call and directions buttons, generic business names, clean light UI, no real logos, 16:9",
        },
        {
            src: "/assets/img/services/gbp-profil.webp",
            alt: "To'ldirilgan Google Business profili: foto, ish vaqti, xizmatlar va tugmalar",
            caption: "To'liq to'ldirilgan profil bo'sh qolganidan bir necha barobar ko'proq harakat keltiradi.",
            prompt:
                "Mockup of a complete Google Business Profile panel: cover photo grid, business name, star rating, category, opening hours, phone, website and directions buttons, services list, clean light interface, generic business, no real logos, 16:9",
        },
        {
            src: "/assets/img/services/gbp-sharhlar.webp",
            alt: "Google sharhlari va ularga yozilgan javoblar — reyting bilan ishlash",
            caption: "Har bir sharhga javob yoziladi, jumladan salbiylariga ham.",
            prompt:
                "Mockup of a Google reviews list with star ratings, several customer reviews in Latin and Cyrillic script, each followed by an owner reply block, one negative review with a calm professional response, clean light UI, no real logos, 16:9",
        },
        {
            src: "/assets/img/services/gbp-nap.webp",
            alt: "NAP birxilligi sxemasi: nom, manzil va telefon barcha manbalarda bir xil",
            caption: "NAP xatolari profilning nufuzini bo'lib yuboradi — ish shundan boshlanadi.",
            prompt:
                "Clean infographic diagram showing one business card in the center connected to website, Google profile, social networks and local directories, with green checkmarks indicating identical name address and phone, flat modern style, blue palette, 16:9",
        },
    ],
    related: ["seo", "google-ads", "korporativ-saytlar", "vizitka-saytlar"],
};

const ru = {
    meta: {
        title: "Профиль Google Business — видимость на карте и локальное SEO",
        description:
            "Настройка и ведение профиля Google Business: выход в локальную выдачу на карте, работа с отзывами, единообразие NAP, фото и посты. Ведение — от 2 500 000 сум в месяц.",
        keywords: [
            "профиль Google Business",
            "Гугл Бизнес профиль",
            "бизнес на картах Google",
            "локальное SEO",
            "локальная выдача",
            "map pack",
            "отзывы в Google",
            "единообразие NAP",
            "поиск рядом со мной",
        ],
    },
    hero: {
        eyebrow: "Google Business / Локальное SEO",
        h1: "Профиль Google Business — попадите в тройку на карте",
        lead:
            "Когда человек ищет «стоматология рядом со мной», Google сначала показывает карту и три компании. Звонок получает тот, кто попал в эту тройку. Мы работаем над тем, чтобы ваш профиль оказался именно там.",
        ctaPrimary: "Бесплатно проверить профиль",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Позиция на карте и запросы маршрута",
            "Ответы на отзывы на узбекском и русском",
            "Данные NAP одинаковы во всех источниках",
            "Ежемесячный отчёт: звонки, маршруты, клики",
        ],
    },
    intro: {
        h: "Что такое профиль Google Business и зачем он нужен",
        p: [
            "Профиль Google Business — бесплатная карточка вашей компании в поиске Google и на Google Maps. В ней указаны адрес, режим работы, телефон, фотографии, перечень услуг и отзывы клиентов. Именно эта карточка появляется, когда вас ищут по названию или набирают запрос вида «рядом со мной».",
            "По локальным запросам Google выводит блок с картой раньше обычных результатов — так называемую тройку, или map pack. На эти три позиции приходится значительная часть кликов в локальном поиске. Быть четвёртым — почти то же самое, что быть пятым: чтобы увидеть остальных, пользователю нужно нажать дополнительную кнопку.",
            "Тройку Google выбирает по трём факторам. Первый — релевантность: насколько данные профиля соответствуют запросу. Второй — расстояние: насколько вы близки к человеку, который ищет. Третий — известность: количество и оценка отзывов, упоминания на сайте, записи в каталогах. Расстояние изменить нельзя, а два остальных фактора полностью в вашей зоне влияния.",
            "В Узбекистане это направление пока используется слабо. У многих компаний профиля либо нет вовсе, либо он не подтверждён, либо данные в нём пятилетней давности. У части бизнесов висят по два-три дубля карточки, и они съедают позиции друг друга. Это канал, который конкуренты игнорируют, а вам он обойдётся дёшево.",
            "Ещё одна частая ошибка — название и адрес написаны везде по-разному. На сайте «Чиланзарский район, 12-й квартал», в профиле «Chilonzor tumani, 12-kvartal», в каталоге вообще иначе. Google не может связать эти записи с одним бизнесом, и вес профиля дробится. Исправление этого называется единообразием NAP, и работу мы обычно начинаем именно с него.",
        ],
    },
    definition: {
        term: "Что такое профиль Google Business?",
        text:
            "Профиль Google Business — бесплатная карточка компании в поиске Google и на Google Maps: адрес, режим работы, телефон, фото, услуги и отзывы клиентов. Это основной инструмент выхода в локальную выдачу на карте.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Что входит в услугу",
        sub: "Работы подбираются по состоянию профиля — точный список выдаём после проверки.",
        items: [
            "Создание профиля или возврат прав владения",
            "Прохождение процедуры подтверждения до конца",
            "Поиск дублей карточек, их объединение или удаление",
            "Единообразие NAP: название, адрес и телефон одинаковы везде",
            "Подбор корректной основной и дополнительных категорий",
            "Заполнение списка услуг и товаров с диапазонами цен",
            "Текст описания на узбекском и русском с ключевыми словами",
            "Настройка режима работы, праздничного графика и зоны обслуживания",
            "Качественные фото и видео: фасад, интерьер, команда, процесс работы",
            "Точная установка метки на карте и входа для клиентов",
            "Система сбора отзывов: QR-код, шаблон SMS, инструкция для персонала",
            "Ответы на все отзывы, включая негативные",
            "Заполнение и мониторинг раздела вопросов и ответов",
            "Еженедельные посты: акции, новости, анонсы услуг",
            "Подключение кнопок заказа и бронирования",
            "Записи в локальных каталогах и профиль Яндекс.Бизнес",
            "Ежемесячный отчёт: показы, звонки, запросы маршрута, переходы на сайт",
        ],
    },
    benefits: {
        eyebrow: "Зачем это нужно",
        h: "Что профиль даёт бизнесу",
        sub: "Для локального бизнеса это самый дешёвый канал привлечения клиентов.",
        items: [
            {
                t: "Выход в тройку на карте",
                d: "По локальным запросам Google сначала показывает три компании. Попасть туда ценнее, чем занять первое место в обычной выдаче.",
            },
            {
                t: "Прямой звонок из карточки",
                d: "Пользователь звонит или строит маршрут кнопкой, даже не заходя на сайт. Чем короче путь, тем больше обращений.",
            },
            {
                t: "Отзывы формируют доверие",
                d: "Большинство начинает выбор с оценки. Профиль с рейтингом 4,7 получает в разы больше звонков, чем профиль с 3,9.",
            },
            {
                t: "Затраты почти нулевые",
                d: "Сам профиль бесплатный. В отличие от рекламы, здесь не нужно платить за каждый показ — нужно только время на ведение.",
            },
            {
                t: "Результат виден быстро",
                d: "SEO требует месяцев ожидания. Заполненный профиль обычно заметно увеличивает показы и звонки уже за 3–6 недель.",
            },
            {
                t: "Помогает SEO сайта",
                d: "Одинаковые данные в профиле, на сайте и в каталогах — сильный сигнал для Google. Это поднимает и локальные позиции самого сайта.",
            },
            {
                t: "Конкуренты этим не занимаются",
                d: "В Узбекистане профили большинства компаний заброшены. При аккуратном ведении профиля обойти их относительно просто.",
            },
        ],
    },
    audience: {
        eyebrow: "Кому подходит",
        h: "Кому нужен профиль Google Business",
        sub: "Любому бизнесу, к которому клиент приезжает или к которому вы выезжаете сами.",
        items: [
            {
                t: "Бизнес с физическим адресом",
                d: "Клиники, рестораны, салоны, магазины, спортзалы. Клиент находит вас на карте и сразу строит маршрут.",
            },
            {
                t: "Выездные услуги",
                d: "Клининг, переезды, ремонт, эвакуатор. Адрес можно скрыть и показывать только зону обслуживания.",
            },
            {
                t: "Сети с несколькими филиалами",
                d: "Для каждого филиала нужен отдельный профиль. При централизованном управлении каждый работает в своём районе.",
            },
            {
                t: "Медицина и образование",
                d: "Здесь выбор почти всегда начинается с чтения отзывов. Профиль в этих нишах — инструмент доверия.",
            },
            {
                t: "Только что открывшиеся точки",
                d: "Даже если сайта ещё нет, профиль начинает приводить первых клиентов. Это канал, который запускается быстрее всех.",
            },
            {
                t: "Те, кто получил негатив",
                d: "Если несколько плохих отзывов обрушили оценку, системная работа восстанавливает рейтинг за несколько месяцев.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость работ с профилем Google Business",
        sub: "Настройка — разово. Ведение — ежемесячная абонентская плата.",
        note:
            "Сам профиль в Google бесплатный: вы платите только за корректную сборку и регулярное ведение. Для сетей цена считается по количеству филиалов. В процессе подтверждения Google иногда присылает код почтой или запрашивает видеопроверку — это добавляет 1–3 недели и от нас не зависит. Вопросы: +998 90 954 12 62.",
        tiers: [
            {
                name: "Настройка",
                tagline: "Разовая полная сборка",
                price: "2 500 000 сум",
                priceNote: "разово",
                term: "5–10 рабочих дней (без учёта подтверждения)",
                best: "Бизнесам, у которых профиля нет или он в заброшенном состоянии",
                features: [
                    "Создание профиля или возврат прав владения",
                    "Сопровождение подтверждения до результата",
                    "Поиск и объединение дублей карточек",
                    "Заполнение категорий, услуг и текста описания",
                    "Приведение данных NAP в соответствие с сайтом",
                    "Загрузка 10–15 фотографий и точная метка на карте",
                    "QR-код и шаблон SMS для сбора отзывов",
                    "Короткое обучение управлению профилем",
                ],
            },
            {
                name: "Ведение",
                tagline: "Ежемесячная работа и рост рейтинга",
                price: "2 500 000 сум",
                priceNote: "в месяц, один филиал",
                term: "Абонентская плата",
                best: "Тем, кто хочет войти в тройку на карте и поднять рейтинг отзывов",
                featured: true,
                features: [
                    "Все работы пакета «Настройка» в первый месяц",
                    "1–2 поста в неделю: акции, новости, услуги",
                    "Ответы на все отзывы в течение 24 часов",
                    "Работа с негативом и жалобы на отзывы, нарушающие правила",
                    "5–10 новых фотографий в месяц",
                    "Заполнение и мониторинг раздела вопросов и ответов",
                    "Записи в локальных каталогах и Яндекс.Бизнес",
                    "Отслеживание позиций конкурентов на карте",
                    "Ежемесячный отчёт: показы, звонки, маршруты, клики",
                ],
            },
            {
                name: "Сеть",
                tagline: "Управление несколькими филиалами",
                price: "6 000 000 сум",
                priceNote: "в месяц, до 3 филиалов",
                term: "Абонентская плата",
                best: "Сетям с филиалами в разных городах или районах",
                features: [
                    "Все работы пакета «Ведение» для каждого филиала",
                    "Каждый дополнительный филиал — 1 500 000 сум в месяц",
                    "Централизованное управление и единый контент-план",
                    "Предотвращение конкуренции филиалов между собой",
                    "Рекомендации по отдельной посадочной странице на филиал",
                    "Сравнительный отчёт в разрезе филиалов",
                    "Инструкция и тренинг для персонала по сбору отзывов",
                    "Персональный менеджер",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как ведётся работа",
        sub: "Первые результаты обычно видны за 3–6 недель — заметно быстрее, чем в SEO.",
        steps: [
            {
                t: "Аудит профиля",
                time: "2–3 дня",
                d: "Проверяем текущий профиль, дубли, ошибки NAP, состояние отзывов и позиции конкурентов на карте. Результат — список проблем.",
            },
            {
                t: "Права владения и подтверждение",
                time: "1–3 недели",
                d: "Профиль переводится на ваше имя и подтверждается. Срок зависит от метода проверки Google — код почтой или видеоподтверждение.",
            },
            {
                t: "Чистка NAP",
                time: "1–2 недели",
                d: "Название, адрес и телефон приводятся к единому написанию на сайте, в профиле, соцсетях и каталогах. Дубли объединяются.",
            },
            {
                t: "Заполнение профиля",
                time: "3–5 дней",
                d: "Категории, услуги, описание, режим работы, фото и метка на карте. Каждое пустое поле — это потерянные показы.",
            },
            {
                t: "Запуск сбора отзывов",
                time: "1 неделя",
                d: "Готовим QR-код, шаблон SMS и инструкцию для сотрудников. Задача — чтобы отзывы приходили регулярно, а не случайно.",
            },
            {
                t: "Постоянное ведение",
                time: "еженедельно",
                d: "Выходят посты, добавляются фото, пишутся ответы на отзывы, закрываются вопросы. Живой профиль — сигнал и для Google.",
            },
            {
                t: "Замеры и корректировка",
                time: "ежемесячно",
                d: "Сравниваем показы, звонки и запросы маршрута. Смотрим, какие посты и фото дали больше действий, и подстраиваем план.",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Проекты, подготовленные под локальный поиск",
        sub: "Эти сайты собраны так, чтобы работать в связке с профилем и картой.",
        cta: "Смотреть все проекты",
        slugs: ["cleanza", "ipsum-pathology", "mountain-and-sea", "global-building-group"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы про Google Business",
        sub: "Конкретные ответы про карту, отзывы и NAP.",
        items: [
            {
                q: "Сколько стоит работа с профилем Google Business?",
                a: "В Innobek разовая настройка стоит 2 500 000 сум, ежемесячное ведение — от 2 500 000 сум. Для сетей цена начинается с 6 000 000 сум, сюда входят до трёх филиалов, каждый следующий — 1 500 000 сум в месяц. Сам профиль в Google бесплатный, вы оплачиваете только работу.",
            },
            {
                q: "Как попасть в тройку на карте (map pack)?",
                a: "Google учитывает три фактора: релевантность профиля запросу, расстояние до пользователя и известность бизнеса. Расстояние изменить нельзя. Над остальным работаем: правильная основная категория, полностью заполненный список услуг, регулярно поступающие отзывы, свежие фотографии, еженедельные посты и локальные сигналы на сайте. При одновременной работе по всем пунктам шансы войти в тройку заметно растут.",
            },
            {
                q: "Через сколько виден результат?",
                a: "После заполнения профиля первые изменения обычно заметны за 3–6 недель: растёт количество показов, звонков и запросов маршрута. Устойчивая позиция в тройке на карте требует 2–4 месяцев регулярной работы, потому что на накопление отзывов и формирование доверия Google нужно время. Это заметно быстрее SEO, но всё же не вопрос одного дня.",
            },
            {
                q: "Что такое единообразие NAP и почему это важно?",
                a: "NAP — это Name, Address, Phone: название, адрес и телефон. Эти три поля должны быть написаны одинаково на сайте, в профиле, соцсетях и всех каталогах. Если адрес где-то на узбекском, где-то на русском, а где-то с сокращениями, Google не связывает записи и вес профиля дробится.",
            },
            {
                q: "Можно ли удалить негативный отзыв?",
                a: "Только если он нарушает правила Google: оскорбления, реклама, текст не по теме или очевидная фальшивка. В этом случае отправляется жалоба, но решение принимает Google и гарантий нет. Настоящую претензию удалить нельзя — правильнее спокойно и предметно ответить и решить проблему клиента.",
            },
            {
                q: "Можно ли купить отзывы?",
                a: "Нет, и мы этого не делаем. Google распознаёт фальшивые отзывы: они удаляются, а профиль может попасть под фильтр или быть удалён совсем. Риск перевешивает выгоду. Вместо этого мы выстраиваем систему сбора настоящих отзывов — QR-код, шаблон SMS и простая инструкция для сотрудников.",
            },
            {
                q: "Сколько отзывов в месяц считается нормой?",
                a: "Зависит от размера бизнеса, но главное правило — ровный и естественный темп. Для небольшой компании 5–15 отзывов в месяц уже хороший показатель. Двадцать отзывов за один день вызывают подозрение и приводят к фильтру. Важно, чтобы поток не прерывался: старые отзывы теряют вес.",
            },
            {
                q: "У меня нет адреса, я выезжаю к клиенту — профиль возможен?",
                a: "Да, возможен. Для таких компаний существует режим зоны обслуживания: адрес скрывается, а вместо него указывается список районов или городов, где вы работаете. В этом режиме работают клининг, переезды, ремонт и эвакуаторы. Реальный адрес всё равно потребуется для подтверждения, но публично он не показывается — клиенты видят только зону.",
            },
            {
                q: "Что делать, если филиалов несколько?",
                a: "Для каждого филиала создаётся отдельный профиль, и все они управляются централизованно из одного аккаунта. Важный момент: если филиалы расположены слишком близко друг к другу, они начинают конкурировать между собой, и позиции проседают у всех. Поэтому категории, списки услуг и тексты описаний мы делаем разными для каждой точки.",
            },
            {
                q: "Профиль зарегистрирован на другого человека — что делать?",
                a: "Это встречается очень часто: профиль когда-то завёл прежний маркетолог, дизайнер или просто знакомый. В Google есть официальная процедура запроса прав владения. Текущему владельцу отправляется запрос, и если он не отвечает в течение 3–7 дней, права на управление переходят к вам. Мы сопровождаем этот процесс от начала до конца.",
            },
            {
                q: "Профиль заменяет SEO сайта?",
                a: "Нет, у них разные задачи. Профиль работает в локальной выдаче и на карте, а SEO сайта охватывает значительно более широкий спектр запросов. Но они усиливают друг друга: корректные данные в профиле поднимают локальные позиции сайта, а сайт добавляет профилю известности.",
            },
        ],
    },
    cta: {
        h: "Хотите узнать, как ваш профиль выглядит на карте?",
        p: "На бесплатной проверке сравним профиль с конкурентами, найдём дубли и ошибки NAP и дадим список того, что нужно исправить.",
        button: "Бесплатно проверить профиль",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/services/gbp-map-pack.webp",
            alt: "Локальная выдача Google на карте: три карточки бизнеса по локальному запросу",
            caption: "По локальным запросам Google сначала показывает карту и три компании.",
            prompt:
                "Mockup of Google local map pack in search results: map on top with three pins, below three business listing cards with star ratings, review counts, addresses and call and directions buttons, generic business names, clean light UI, no real logos, 16:9",
        },
        {
            src: "/assets/img/services/gbp-profil.webp",
            alt: "Заполненный профиль Google Business: фото, режим работы, услуги и кнопки",
            caption: "Полностью заполненный профиль приносит в разы больше действий, чем пустой.",
            prompt:
                "Mockup of a complete Google Business Profile panel: cover photo grid, business name, star rating, category, opening hours, phone, website and directions buttons, services list, clean light interface, generic business, no real logos, 16:9",
        },
        {
            src: "/assets/img/services/gbp-sharhlar.webp",
            alt: "Отзывы в Google и ответы на них — работа с рейтингом компании",
            caption: "Ответ пишется на каждый отзыв, в том числе на негативный.",
            prompt:
                "Mockup of a Google reviews list with star ratings, several customer reviews in Latin and Cyrillic script, each followed by an owner reply block, one negative review with a calm professional response, clean light UI, no real logos, 16:9",
        },
        {
            src: "/assets/img/services/gbp-nap.webp",
            alt: "Схема единообразия NAP: название, адрес и телефон одинаковы во всех источниках",
            caption: "Ошибки NAP дробят вес профиля — с их исправления и начинается работа.",
            prompt:
                "Clean infographic diagram showing one business card in the center connected to website, Google profile, social networks and local directories, with green checkmarks indicating identical name address and phone, flat modern style, blue palette, 16:9",
        },
    ],
    related: ["seo", "google-ads", "korporativ-saytlar", "vizitka-saytlar"],
};

const content = { uz, ru };

export default content;
